import { property} from '@wonderlandengine/api/decorators.js';
import { EToy } from './etoy.js';
import { EventsClient } from '../events-client.js';
import { vec3 } from 'gl-matrix';
import { IntifaceController, SupportedAction } from '../IntifaceController.js';
import Logger from '../utils/logger.js';

const MODULE = 'ProximityVibe';

/**
 * proximity-vibe
 */
export class ProximityVibe extends EToy {
    static TypeName = 'proximity-vibe';

    /* Properties that are configurable in the editor */

    @property.float(4.0)
    minEffectDistance: number = 4.0;
    @property.float(0.25)
    maxEffectDistance: number = 0.25;
    @property.float(0.0)    
    minEffectIntensity: number = 0.1;
    @property.float(1.0)
    maxEffectIntensity: number = 1.0;
    @property.int(10)
    updatesPerSecond: number = 10.0;
    @property.float(500)
    sustainMs: number = 500.0;

    private _accumulator = 0;
    private _tmpSelf = vec3.create();
    private _tmpPlayer = vec3.create();

    update(dt: number) {
        this._accumulator += dt;
        const interval = 1 / Math.max(1, this.updatesPerSecond);
        if (this._accumulator < interval) return;
        this._accumulator = 0;

        const player = EventsClient.instance?.activePlayerObject;
        if (!player) {
            Logger.warn('[ProximityVibe] No playerObject; skipping', MODULE);
            return;
        }

        this.object.getPositionWorld(this._tmpSelf);
        player.getPositionWorld(this._tmpPlayer);
        const dx = this._tmpSelf[0] - this._tmpPlayer[0];
        const dy = this._tmpSelf[1] - this._tmpPlayer[1];
        const dz = this._tmpSelf[2] - this._tmpPlayer[2];
        const dist = Math.hypot(dx, dy, dz);

        let magnitude = 0;
        if (dist >= this.minEffectDistance) {
            magnitude = 0;
        } else if (dist <= this.maxEffectDistance) {
            magnitude = this.maxEffectIntensity;
        } else {
            const t = (this.minEffectDistance - dist) / (this.minEffectDistance - this.maxEffectDistance);
            magnitude = this.minEffectIntensity + t * (this.maxEffectIntensity - this.minEffectIntensity);
        }

        IntifaceController.instance.hapticEnvironment.registerInfluence(this.object, SupportedAction.Vibrate, [magnitude, magnitude/2], this.sustainMs);
    }
}
